export default __webpack_public_path__ + "static/media/rider_big.ad377afe.png";